import React from 'react';
import HelpWidgetItem from 'emerald-ui/lib/HelpWidget/HelpWidgetItem';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: HelpWidgetItem, componentName: 'HelpWidgetItem' }], 'HelpWidgetItem'),
  description: (
    <span>
      An item for the <span className="code">HelpWidget</span> component. It‘s highly recommended to be used through{' '}
      <span className="code">Help Widget</span> with the tag <span className="code">HelpWidget.Item</span>.
    </span>
  ),
};
